import type { StatusType, Column, MobileConfig } from '@chikara/ui';
import { t } from '@/i18n';

export const STATUS_TYPE_MAP: Record<string, StatusType> = {
    active: 'activa',
    blocked: 'bloqueada',
    inactive: 'inactiva',
    cancelled: 'inactiva',
    requested: 'solicitada',
    received: 'recibida',
    pending_approval: 'pendiente',
    enabled: 'activa',
    disabled: 'inactiva',

    ordered: 'ordered',
    confirm: 'confirm',
    customazing: 'customazing',
    sent: 'sent',
    on_transit: 'on_transit',
};

export function getStatusType(status: string): StatusType {
    return STATUS_TYPE_MAP[status] ?? 'pendiente';
};

export const ACTIVITY_MOVEMENT_COLUMNS: Column[] = [
    { key: 'cdate', label: t('dashboard.card.detail.activity.table.date'), width: '20%', align: 'center' },
    { key: 'movement', label: t('dashboard.card.detail.activity.table.movement'), width: '35%' },
    { key: 'amount', label: t('dashboard.card.detail.activity.table.amount'), width: '15%' },
    { key: 'type', label: t('dashboard.card.detail.activity.table.type'), width: '15%' },
    { key: 'status', label: t('dashboard.card.detail.activity.table.status'), width: '15%' },
    { key: 'cdate_mobile', label: t('dashboard.table.date'), isMobile: true },
    { key: 'pan_masked', label: t('dashboard.table.pan_masked'), isMobile: true },
];

export const ACTIVITY_MOVEMENT_MOBILE_CONFIG: MobileConfig = {
    primaryField: 'movement',
    expandableFields: ['email', 'cdate_mobile', 'pan_masked', 'amount', 'type', 'status'],
};